import claudeCode from './claudeCode';
import claudeDesktop from './claudeDesktop';
import vsCode from './vsCode';
import cursor from './cursor';
import cline from './cline';
import copilotStudio from './copilotStudio';
import chatGpt from './chatGpt';

const clients = [
  claudeCode,
  claudeDesktop,
  vsCode,
  cursor,
  cline,
  copilotStudio,
  chatGpt
];

/**
 * GET CLIENT BY ID
 * @param {string} id - the client id held in component state
 * @return {Object} the matching client, or the first one when the id is unknown
 */
export const getClientById = (id) => clients.find((client) => client.id === id) || clients[0];

export default clients;
